import { useSelector } from 'react-redux';
import { RootState } from 'store';

const Card = ({
  step,
  title,
  description,
  lightImage,
  darkImage,
}: {
  step: number;
  title: string;
  description: string;
  lightImage: string;
  darkImage: string;
}) => {
  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);

  return (
    <div className="flex flex-col h-full overflow-hidden rounded-lg flex-1">
      <div className="flex flex-col text-start p-6 bg-gray-100 dark:bg-gray-800">
        <div className="text-primary text-sm font-bold mb-1">STEP {step}</div>
        <h3 className="text-text-primary text-xl font-semibold mb-2">{title}</h3>
        <p className="text-text-secondary text-sm leading-relaxed">
          {description}
        </p>
      </div>
      <div
        className="bg-cover bg-center bg-no-repeat w-full h-40"
        style={{
          backgroundImage: `url(${isDarkMode ? darkImage : lightImage})`,
        }}
      />
    </div>
  );
};

export default Card;
